<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.98299 16.975C0.482991 16.975 -0.517009 15.275 0.282991 13.975L7.78299 0.975C8.58299 -0.325 10.483 -0.325 11.283 0.975L18.783 13.975C19.583 15.275 18.583 16.975 17.083 16.975H1.98299ZM17.083 14.975L9.48299 1.975L1.98299 14.975H17.083ZM8.48299 6.975V8.975C8.48299 9.575 8.88299 9.975 9.48299 9.975C10.083 9.975 10.483 9.575 10.483 8.975V6.975C10.483 6.375 10.083 5.975 9.48299 5.975C8.88299 5.975 8.48299 6.475 8.48299 6.975ZM10.483 13.975V11.975H8.48299V13.975H10.483Z" fill="white"></path>
</template>

<script>
    export default {
        name: 'icon-alert'
    }
</script>